import { GET_LOADS } from "constants/loads";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_LOADS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
